import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { connect } from 'react-redux';
import {useBrowser} from 'js/hooks/useBrowser';
import Button from 'js/components/shared/Button';
import { searchBox } from '../../drupalSettings';
import ModuleByKey from '../../components/ModuleByKey';
import { isMobiles } from 'js/helpers/browser';

import styles from './SearchViewPannel.module.scss';
import StickyComponent from '../../components/StickyComponent';

const cx = classnames.bind(styles);
const wordings = searchBox?.titles;
const SEARCH_STICKY_WRAP = 'search-sticky';

const SearchViewPannel = function ({
  className,
  modules,
  onSubmit,
  loading,
  onModuleChange,
  displaySubmit = true,
  isSearchBoxInHeader = true,
}) {
  const browser = useBrowser();
  const isMobileVersion = isMobiles(browser);

  const onModuleSubmit = function () {
    if (isMobileVersion) {
      onSubmit();
    }
  };

  const onSubmitClick = function (e) {
    e.preventDefault();
    e.stopPropagation();

    onSubmit();
  }

  const isStickyEnabled = useMemo(function () {
    return !isSearchBoxInHeader && !isMobileVersion;
  }, [isSearchBoxInHeader, isMobileVersion]);

  const searchControls = (
    <div className={cx('wrap')}>
      {modules.map((module, i) => (
        <ModuleByKey
          info={module}
          key={i}
          onChange={onModuleChange}
          onSubmit={onModuleSubmit}
          className={cx('module', module)}
        />
      ))}
      {displaySubmit && (
        <Button
          type="submit"
          size="xl"
          theme="squared"
          loading={loading}
          className={cx('submit-btn')}
          onClick={onSubmitClick}
        >
          {wordings.searchButtonValue}
        </Button>
      )}
    </div>
  );

  return (
    <StickyComponent
      className={cx('root', className)}
      wrapEl={SEARCH_STICKY_WRAP}
      stickyClassName={cx('sticky')}
      offset={100}
      enabled={isStickyEnabled}
    >
      {searchControls}
    </StickyComponent>
  );
};

SearchViewPannel.propTypes = {
  className: PropTypes.string,
  modules: PropTypes.array,
  onSubmit: PropTypes.func,
  loading: PropTypes.bool,
  onModuleChange: PropTypes.func.isRequired,
  displaySubmit: PropTypes.bool,
  isSearchBoxInHeader: PropTypes.bool,
};

export default SearchViewPannel;
